import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=3db11e38&scoped=true&"
import script from "./category-list.vue?vue&type=script&lang=ts&"
export * from "./category-list.vue?vue&type=script&lang=ts&"
import style0 from "./category-list.vue?vue&type=style&index=0&id=3db11e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db11e38",
  null
  
)

export default component.exports